import { User } from '../../../authentication/auth_widget/authState'

type TokenResponse = { token: string }

export const getToken = async (user: User): Promise<TokenResponse> => {
  const headers = new Headers()
  headers.append('accept', 'application/json')
  headers.append('content-type', 'application/json')
  return fetch('/api/v1/hubspot/tracking/createtoken', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      email: user.email,
    }),
  })
    .then((r) => r.json())
    .then((r) => r as TokenResponse)
}
